import { render, staticRenderFns } from "./SkillsChips.vue?vue&type=template&id=6e2ede75&scoped=true"
import script from "./SkillsChips.vue?vue&type=script&lang=ts"
export * from "./SkillsChips.vue?vue&type=script&lang=ts"
import style0 from "./SkillsChips.vue?vue&type=style&index=0&id=6e2ede75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ede75",
  null
  
)

export default component.exports